export const mapForSpecificCount = (cb, count) => {
  const output = []

  for(let i = 0; i < count; i++) {
    output.push(cb(i))
  }

  return output
}

export const sortByName = (a, b) => a.name.toLowerCase() > b.name.toLowerCase()
  ? 1
  : a.name.toLowerCase() < b.name.toLowerCase()
    ? -1
    : 0

export const map = (array, callback) => {
  const output = []

  for(let i = 0; i < array.length; i++) {
    const item = array[i]
    const result = callback(item, i, array)

    output.push(result)
  }
  return output
}

export const indexOf = (array, cb) => {
  let index = -1

  for(let i = 0; i < array.length; i++) {
    const item = array[i]

    if(cb(item)) {
      index = i
      break
    }
  }

  return index
}